
import React from 'react'
import Page from '../components/Page';
import { RateApp } from 'capacitor-rate-app';
import { Link } from 'react-router-dom';

const About = () => (
  <Page title="About" padding>
    <h3>About this app</h3>
    <p>
      I created many features of this app in a hurry for the release of d2r. Naturally, many improvements are still required.
    </p>
    <p>
      If you have suggestions, bugreports or comments <a href="mailto:luca@naterop.net">please reach out to me</a>. I'll have an open ear for you.
    </p>
    <p>
      If you would like to support the development of this app, consider{' '}
      <a href="#" onClick={e => { e.preventDefault(); RateApp.requestReview(); }}>rating this app</a>
      {' '}or making a small{' '}
      <a href="https://paypal.me/lucanaterop" target="_blank" rel="noreferrer">donation</a>.
    </p>
    <p style={{marginTop: 32}}>
      <Link to="/privacy">Privacy Policy</Link>
    </p>
  </Page>
);

export default About;
